export interface AuditLogChangedFieldConstructorData {
  field: string
  from: string | number | string[]
  to: string | number | string[]
}

export class AuditLogChangedField {
  field: string
  from: string | number | string[]
  to: string | number | string[]

  constructor(data: AuditLogChangedFieldConstructorData) {
    this.field = data.field
    this.from = data.from
    this.to = data.to
  }
}
